import React from 'react';
import { useField } from 'formik';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  InputGroupText,
  InputProps,
} from 'reactstrap';
import { useTranslator } from '../I18n/useTranslator';

interface FormikSelectProps extends InputProps {
  label?: string;
  inline?: boolean;
  required?: boolean;
  translateErrMsg?: boolean;
  unit?: string;
  name: string;
}

const FormikSelect: React.FC<FormikSelectProps> = ({
  label,
  inline = false,
  required = false,
  translateErrMsg = false,
  unit,
  ...props
}) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input>. We can use field meta to show an error
  // message if the field is invalid and it has been touched (i.e. visited)
  const [field, meta] = useField(props.name);
  const { t } = useTranslator();

  return (
    <FormGroup className="mb-m">
      <Row className="align-items-center">
        {label && (
          <Col xs={inline ? '7' : '12'}>
            <Label for={props.id || props.name} className={inline ? 'mb-0' : ''}>
              {required && <sup>*</sup>} {label}
            </Label>
          </Col>
        )}

        <Col xs={inline ? '5' : '12'}>
          {unit ? (
            <div
              className={`input-group-with-addon ${meta.touched && meta.error ? 'is-invalid' : ''}`}
            >
              <Input {...field} {...props} type="select" invalid={!!(meta.touched && meta.error)}>
                {props.children}
              </Input>
              <InputGroupText style={{ paddingLeft: '30%' }}>{unit}</InputGroupText>
            </div>
          ) : (
            <Input {...field} {...props} type="select" invalid={!!(meta.touched && meta.error)}>
              {props.children}
            </Input>
          )}

          {meta.touched && meta.error && (
            <FormFeedback>{translateErrMsg ? t(meta.error) : meta.error}</FormFeedback>
          )}
        </Col>
      </Row>
    </FormGroup>
  );
};

export default FormikSelect;
